"use client";

import { useGlobalContext } from "@/context/store";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useDisconnect } from "wagmi";

export default function WalletButton() {
  const { lang, activeLang } = useGlobalContext();
  const { disconnect } = useDisconnect();
  const [text, setText] = useState("Connect Wallet");

  useEffect(() => {
    setText(lang.CONNECT_WALLET || "Connect Wallet");
  }, [activeLang]);

  useEffect(() => {
    const hasDisconnected = sessionStorage.getItem("walletDisconnected");

    if (!hasDisconnected) {

      setTimeout(() => {
        disconnect();
        sessionStorage.setItem("walletDisconnected", "true");
      }, 2000);
    } else {
    }

    setTimeout(() => {
      disconnect();
      sessionStorage.setItem("walletDisconnected", "true"); 
    }, 10 * 60 * 1000);
  }, [disconnect]);

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== "loading";
        const connected = ready && account && chain;

        return (
          <div
            onClick={connected ? openAccountModal : openConnectModal}
            className="flex items-center bg-[#ED1C24] text-white px-4 py-2 rounded cursor-pointer hover:opacity-90 transition"
          >
            <Image
              src="/icons/wallet.svg"
              alt="Wallet Icon"
              width={18}
              height={18}
              className="mr-2"
            />
            <span className="text-sm font-medium">
              {connected
                ? `${account.displayName.slice(
                    0,
                    6
                  )}...${account.displayName.slice(-4)}`
                : text}
            </span>
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}
